// extracted by mini-css-extract-plugin
export var numpadContainer = "_ps-1";
export var phoneButton = "_ps-0";